import "./switch.css";
import { Switch } from './switch';
export default Switch;